/**
*
* PluginDetails
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import {
  commandWorkspacePluginDetails,
  commandWorkspacePluginCollaboratorSummary,
  commandWorkspacePluginPermissionRevoke,
} from 'containers/ConnectionManager/actions';
import { selectPluginDetails } from 'Workspace/Plugins/store/selectors';
import pluginDetailsShape from 'Workspace/types/pluginDetails';
import gtmService from 'utils/gtm/gtmService';
import { selectCurrentMe } from 'data/CurrentUser/selectors';

import PluginVersionListPage from '../PluginVersionListPage';
import PluginSetup from '../PluginSetup';
import PluginDetails from './PluginDetails';

class PluginRouter extends React.Component {
  componentDidMount() {
    this.props.getPluginDetails(this.props.match.params.pluginId);
    this.props.getPluginCollaboratorSummary(this.props.match.params.pluginId);
    if (this.props.location) {
      const { pathname } = this.props.location;
      gtmService.pushTelemetryPageActivityAndView({ pageName: pathname });
    }
  }

  render() {
    const {
      pluginDetails,
      revokePermission,
      match: { params: { pluginId } },
      currentUser,
    } = this.props;

    return (
      <Switch>
        <Route
          path="/plugins/:pluginId/versions"
          render={(props) => (
            <PluginVersionListPage
              {...props}
              summary={pluginDetails && pluginDetails.summary}
              pluginId={pluginId}
              currentUser={currentUser}
            />
          )}
        />
        <Route
          path="/plugins/:pluginId/setup"
          render={(props) => (
            <PluginSetup
              {...props}
              summary={pluginDetails && pluginDetails.summary}
            />
          )}
        />
        <Route
          path="/plugins/:pluginId"
          render={(props) => (
            <PluginDetails
              {...props}
              summary={pluginDetails && pluginDetails.summary}
              pluginId={pluginId}
              manifest={pluginDetails && pluginDetails.manifest}
              collaborators={pluginDetails && pluginDetails.collaborators}
              onRevoke={(account) => revokePermission(account.id, account.type, pluginId)}
              currentUser={currentUser}
            />
          )}
        />
      </Switch>
    );
  }
}

PluginRouter.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pluginId: PropTypes.string,
    }),
  }),
  pluginDetails: pluginDetailsShape,
  getPluginDetails: PropTypes.func,
  getPluginCollaboratorSummary: PropTypes.func,
  revokePermission: PropTypes.func,
  location: PropTypes.object,
  currentUser: PropTypes.shape({
    accountId: PropTypes.string.isRequired,
  }),
};

const mapDispatchToProps = (dispatch) => ({
  getPluginDetails: (pluginId) => dispatch(commandWorkspacePluginDetails(pluginId)),
  getPluginCollaboratorSummary: (pluginId) => dispatch(commandWorkspacePluginCollaboratorSummary(pluginId)),
  revokePermission: (accountOrTeamId, type, pluginId) => dispatch(commandWorkspacePluginPermissionRevoke(accountOrTeamId, type, pluginId)),
});

const mapStateToProps = (state, ownProps) => ({
  pluginDetails: selectPluginDetails(state, ownProps.match.params.pluginId),
  currentUser: selectCurrentMe(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(PluginRouter);
